import { AuthType } from './types';
import { UserManager } from 'oidc-client-ts';
import { cognitoAuthConfig } from './cognito/cogitoAuthConfig';
import { oidcUserManager } from './oidc/userManager';

// Mirrors getAuthToken: whatever that reads to authenticate a request, this discards.
// A stale token left behind sends the sign-in page straight back to a dead session,
// which is what forced users to clear cookies by hand.
export const clearAuthSession = async (): Promise<void> => {
  const authType: AuthType = import.meta.env.VITE_API_AUTH_STRATEGY;

  switch (authType) {
    case 'cognito': {
      await new UserManager(cognitoAuthConfig).removeUser();
      return;
    }
    case 'oidc-federated': {
      await oidcUserManager.removeUser();
      return;
    }
    case 'local':
    case 'cn': {
      localStorage.removeItem('authToken');
      return;
    }
    default: {
      const type: never = authType;
      throw new Error(`Unsupported auth type found in clearAuthSession: ${type}`);
    }
  }
};
